import { gql } from "@apollo/client";

export const BUILDING_PET_POLICY_FIELDS_FRAGMENT = gql`
  fragment BuildingPetPolicyFieldsV2 on BuildingInterface {
    id
    slug
    petPolicy
    petFriendly
    __typename
  }
`;

export default BUILDING_PET_POLICY_FIELDS_FRAGMENT;
